import { Component, Input, OnInit } from "@angular/core";
import {
  AlertController,
  LoadingController,
  NavParams,
  PopoverController,
  ToastController,
} from "@ionic/angular";
import { GetDropDownCalls } from "src/app/services/get-dropdown-calls.service";
import { SharedServices } from "src/app/services/shared.service";
import { UtilityService } from "src/app/core-files/utility-services/utility.service";
import { MatDialog } from "@angular/material/dialog";
export interface DialogData {
  animal: string;
  name: string;
}
@Component({
  selector: "app-popover-component",
  templateUrl: "./popover-component.component.html",
  styleUrls: ["./popover-component.component.scss"],
  standalone: false
})
export class PopoverComponentComponent implements OnInit {
  animal: string;
  name: string;

  reportList: any = [];
  anyReportObject: any = {};
  @Input() PropertyId;
  @Input() StatusTypeId;

  constructor(
    public popoverController: PopoverController,
    private sharedServices: SharedServices,
    navParams: NavParams,
    public dialog: MatDialog,
    private alertCtrl: AlertController,
    private getDropDownCalls: GetDropDownCalls,
    private loadingController: LoadingController,
    private toastController: ToastController,
    public utilityService: UtilityService
  ) {}

  ngOnInit() {
    this.getDropDownCalls.GetAnyReportMaster(this.StatusTypeId).subscribe({ next: (res) => {
      this.reportList = res;
    } });
  }

  submitReport(type, Id, PropertyId) {
    this.popoverController.dismiss();

    this.anyReportObject = {
      PropertyMasterId: PropertyId,
      ReportMasterId: Id,
      Description: "",
    };

    if (type == "Other Reason") {
      this.openDialog();
    } else {
      this.openAlert(this.anyReportObject, false);
    }
  }
  async openDialog() {
    let alert = await this.alertCtrl.create({
      header:'Other comment',
      inputs: [
        {
          name: "report",
          placeholder: "Enter your comment",
        },
      ],
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          handler: (data) => {},
        },
        {
          text: "Submit Report",
          handler: (data) => {
            this.openAlert(this.anyReportObject, true);
            this.anyReportObject.Description = data.report;
          },
        },
      ],
    });
    alert.present();
  }

  async openAlert(anyReportObject, deleteType) {
    const alert = await this.alertCtrl.create({
      cssClass: "my-custom-class",
      header: "Confirm!",
      message: "<strong>Are you sure reported to property?</strong>",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Report",
          handler: async () => {
            const loading = await this.loadingController.create({
              cssClass: "my-custom-class",
              message: "Please Wait...",
            });
            await loading.present();
            this.sharedServices.AnyReport(anyReportObject).subscribe({
              next: async (res) => {
                this.utilityService.toggleIsChangealue(true);
                await loading.dismiss();
                const toast = await this.toastController.create({
                  message: "Successfully reported.",
                  position: "top",
                  duration: 3000,
                  color: "success",
                });
                toast.present();
              },
              error: async (error) => {
                await loading.dismiss();
              }
            });
          },
        },
      ],
    });
    await alert.present();
  }
}
